module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhand5-c2356a09b33dccc7eed780d54e7392b6.jpg";